<template>
  <template v-if="!region">
    <CompareRegions />
  </template>
  <h3 class="md-heading">Tarkastele oman alueesi valtuutettuja</h3>
  <p class='md-paragraph'>
    Valitse hyvinvointialue nähdäksesi eri puolueiden ja valitsijayhdistysten aluevaltuutettujen mielipiteet.
  </p>
  <CompareParties :region="region" />
</template>

<script>
import CompareParties from './components/CompareParties.vue'
import CompareRegions from './components/CompareRegions.vue'

export default {
  name: 'App',
  components: {
    CompareParties,
    CompareRegions,
  },
  props: {
    region: String,
  },
  data() {
    return {
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss">
/* body {
  background-color: white;
  color: black;
} */
#app-2022-02-aluevaalit-vaalikonevastaukset {
  max-width: 1000px;
  margin: 0 auto;
  font-family: 'Open Sans', sans-serif;
  // padding: 0 16px;

  .filters {
    max-width: 980px;
    margin: 0;

    .select-label {
      font-family: 'Open Sans', sans-serif;
      font-weight: bold;
      font-size: 18px;
      line-height: 27px;
      margin: 0 0 15px 0;
      display: block;
      @media (max-width: 767px) {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  .radio-filters {
    border: none;
    padding: 0;
    margin: 0 0 24px 0;
    @media (max-width: 767px) {
      margin: 0 0 16px 0;
    }

    label {
      display: inline-block;
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: 18px;
      margin-right: .5em;
      white-space: nowrap;
      @media (max-width: 767px) {
        font-size: 16px;
      }
    }
  }

  .questions-wrapper {
    margin-bottom: 2em;
  }

  .question {
    margin-bottom: 2em;
  }

  .loading {
    height: 300px;
  }

  .md-heading {
    font-family: 'Yle Black', 'Yle', 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 20px;
    font-weight: 900;
    line-height: 28px;
    text-align: left;
    margin: 0 0 24px 0;
    padding: 24px 0 0 0;
    @media (max-width: 767px) {
      font-size: 18px;
      line-height: 25.2px;
      margin: 0 0 16px 0;
      padding: 16px 0 0 0;
    }
  }
  .md-paragraph {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    margin: 0 0 24px 0;
    padding: 0;
    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 24px;
      margin: 0 0 16px 0;
    }
  }

  .yddviz-select {
    display: block;
    margin-bottom: .5em;
    border: 2px solid #333;
    border-radius: 6px;
    padding: 6px;
    width: 100%;
    font-size: 16px;
    line-height: 1.5;
    font-weight:bold;

    &:focus {
      outline: none;
      border: 2px dashed #333;
      background: #f5f5f5;
    }
  }

  .yddviz-button {
    border: none;
    position: relative;
    display: block;
    margin: 0 auto;
    border: 0;
    font-weight: 700;
    font-size: 14px;
    padding: 8px 24px;
    line-height: 1.5;
    font-family: 'Open Sans', sans-serif;
    text-decoration: none;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 400px;
    min-height: 32px;
    min-width: 32px;
    cursor: pointer;
    color: #131415;
    background-color: transparent;
    box-shadow: 0 0 0 2px inset #131415;

    &:hover, &:active {
      background: rgba(0, 0, 0, 0.09);
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 666px;
      opacity: 0;
      box-shadow: 0 0 0 2px white, 0 0 0 4px black;
      pointer-events: none;
      box-sizing: border-box;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible:before {
      opacity: 1;
    }
  }

  .select {
    max-width: 300px;
    margin: 5px 0 25px 0;
    padding: 3px 10px;
    border: none;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
  }
  .no-options {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
  }
  .select .vs__dropdown-toggle {
    border: none;
  }
  .select .vs__dropdown-menu {
    max-height: 200px;
  }
}
</style>
